import axios from 'axios';
import { routePage } from '../store/route-page';
import { STATUS, status } from '../store/status';

const baseURL = process.env.REACT_APP_BASE_URL;

export function downloadRoutePage({ uid, code, keepOldOrder }) {
  return axios.get(`/routePages/findWithUid/${uid}/${code}`, { baseURL })
    .catch((error) => {
      if (error.response.status === 401) {
        status.set(STATUS.ERROR_UNAUTHORIZED);
        throw STATUS.ERROR_UNAUTHORIZED;
      } else {
        status.set(STATUS.ERROR_OTHER);
        throw STATUS.ERROR_OTHER;
      }
    })
    .then(({ data: { found: [foundRoutePage], addresses } }) => {
      if (foundRoutePage === undefined) {
        status.set(STATUS.NOT_FOUND);
        throw STATUS.NOT_FOUND;
      } else {
        const { agency, agencyLocation, driver, date, editable, stops } = foundRoutePage;
        routePage.update({ agency, agencyLocation, driver, date, code, editable, stops, addresses, keepOldOrder });
        status.set(STATUS.FOUND);
        return routePage;
      }
    });
}

export function uploadRoutePageOrder({ uid, code }) {
  if (status.get() === STATUS.FOUND) {
    const stops = routePage.getStopsToSend();
    return axios.post(`/routePages/sortStopsWithUid/${uid}/${code}`, { stops }, { baseURL })
      .catch((error) => {
        throw error.response.data.error;
      })
      .then(() => true);
  }
  return Promise.reject(STATUS.ERROR_OTHER);
}



// WEBPACK FOOTER //
// ./src/helpers/api.js